import { ApiCacheOptions } from '../../shared/api/api-cache-options.model';
import { SalesOpportunitySearchDto } from './dto/sales-opportunity-search.dto';
import { ApiService } from '../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { SalesOpportunityDto } from './dto/sales-opportunity.dto';
import { SalesOpportunityProbabilityDto } from './dto/sales-opportunity-probability.dto';
import { SalesOpportunitySourceDto } from './dto/sales-opportunity-source.dto';
import { PagedResultGeneric } from 'src/app/shared';
import { SalesOpportunityLostReasonDto } from './dto/sales-opportunity-lost-reason.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesOpportunityService {
  constructor(private _apiService: ApiService) {}

  get(salesOppId: number): Promise<SalesOpportunityDto> {
    return this._apiService.get(`SalesOpportunity/${salesOppId}`);
  }

  create(salesOpp: SalesOpportunityDto): Promise<SalesOpportunityDto> {
    return this._apiService.post('SalesOpportunities', salesOpp);
  }

  update(salesOpp: SalesOpportunityDto): Promise<SalesOpportunityDto> {
    return this._apiService.put(`SalesOpportunity/${salesOpp.SalesID}`, salesOpp);
  }

  searchSalesOpportunityProbabilities(keyword = ''): Promise<PagedResultGeneric<SalesOpportunityProbabilityDto>> {
    return this._apiService.get(`SalesOpportunityProbabilities?Keyword=${keyword}`);
  }

  searchSalesOpportunitySources(keyword = ''): Promise<PagedResultGeneric<SalesOpportunitySourceDto>> {
    return this._apiService.get(`SalesOpportunitySources?Keyword=${keyword}`);
  }

  searchSalesOpportunityLostReasons(keyword = ''): Promise<PagedResultGeneric<SalesOpportunityLostReasonDto>> {
    return this._apiService.get(`SalesOpportunityLostReasons?Keyword=${keyword}`);
  }

  search(search: SalesOpportunitySearchDto, forceRefresh?: boolean): Promise<PagedResultGeneric<SalesOpportunityDto>> {
    if (forceRefresh) {
      const cacheOpts = this._apiService.getDefaultApiCacheOptionsForNoCache();
      return this._apiService.getPaged('SalesOpportunities', search, cacheOpts);
    } else {
      return this._apiService.getPaged('SalesOpportunities', search);
    }
  }

  searchPost(search: SalesOpportunitySearchDto): Promise<PagedResultGeneric<SalesOpportunityDto>> {
    return this._apiService.post('SalesOpportunities/Search', search);
  }

  delete(salesOppId: number) {
    return this._apiService.delete(`SalesOpportunity/${salesOppId}`);
  }
}
